import { render, staticRenderFns } from "./ImprestCard.vue?vue&type=template&id=37de01b8&scoped=true"
import script from "./ImprestCard.vue?vue&type=script&lang=js"
export * from "./ImprestCard.vue?vue&type=script&lang=js"
import style0 from "./ImprestCard.vue?vue&type=style&index=0&id=37de01b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37de01b8",
  null
  
)

export default component.exports